"use client"

import NextLink from "next/link"
import { useParams } from "next/navigation"
import { useTranslation } from "react-i18next"
import "../assets/css/error.css"

const ErrorPage = ({ error }) => {
  const { t } = useTranslation("error")
  const params = useParams()
  const locale = typeof params?.locale === "string" ? params.locale : "vi"
  const statusCode = error?.code || 500

  return (
    <main className="server-error-page">
      <div className="server-error-page__grain" aria-hidden="true" />
      <header className="server-error-header"><NextLink href={`/${locale}`} aria-label="The Ciu home page"><img src="/assets/icons/logo.svg" alt="The Ciu" /></NextLink><span>the ciu / {statusCode}</span></header>
      <section className="server-error-content">
        <div className="server-error-copy">
          <p className="server-error-eyebrow"><span /> {t("server_error.eyebrow")}</p>
          <h1>{t("server_error.title_before")}<br /><em>{t("server_error.title_accent")}</em> {t("server_error.title_after")}</h1>
          <p>{t("server_error.description")}</p>
          <NextLink href={`/${locale}`} className="server-error-button">{t("server_error.home")} <span aria-hidden="true">↗</span></NextLink>
        </div>
        <div className="server-error-art" aria-hidden="true"><div className="server-error-art__circle" /><strong>{statusCode}</strong><div className="server-error-art__needle" /><span className="server-error-art__spark server-error-art__spark--one">✳</span><span className="server-error-art__spark server-error-art__spark--two">✦</span><small>{t("server_error.art_caption")}</small></div>
      </section>
      <footer className="server-error-footer"><span>{t("server_error.footer")}</span><span /><span>© The Ciu</span></footer>
    </main>
  )
}

export default ErrorPage
